import React from "react";
import "../styles/reusableModal.css";

const ReusableModal = ({ 
  open, 
  onClose, 
  onConfirm, 
  title = "Notice", 
  message = "", 
  confirmText = "Confirm", 
  cancelText = "Cancel" 
}) => {
  if (!open) return null;

  return (
    <div className="custom-modal-backdrop">
      <div className="modal-container">
        <h3>{title}</h3>
        <p>{message}</p>

        <div className="modal-actions">
          <button className="btn-secondary" onClick={onClose}>
            {cancelText}
          </button>
          <button className="btn-primary" onClick={onConfirm}>
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReusableModal;

